import ActionMenu from "../../../../../components/actionMenu/ActionMenu";
import { receptionRoutes } from "../../../../../router/routesConstants";

function ReturningTasksActionButton({ itemId, crudData }: any) {
  return (
    <ActionMenu
      minItemsForMenu={2}
      title={crudData.pctDeLivr}
      ariaLabel={`Actiuni pentru returul ${itemId}`}
      items={[
        {
          id: "return-form",
          label: "Formular retur",
          icon: "RETURNING_DOCUMENT",
          tooltip:
            crudData?.status == 2
              ? "Returul este finalizat; formularul nu mai poate fi completat."
              : "Deschide formularul pentru completarea returului.",
          disabled: crudData?.status == 2,
          navigate: `/${receptionRoutes.returns}/${receptionRoutes.createReturnForm}?id=${itemId}`,
        },
        {
          id: "differences",
          label: "Diferente",
          icon: "DIFFERENCES",
          tooltip:
            "Afiseaza diferentele dintre cantitatile din depozit si cele receptionate in WMS.",
          navigate: `/${receptionRoutes.returns}/${receptionRoutes.returnDifferences}?id=${itemId}&pctDeLivr=${crudData.pctDeLivr}`,
        },
      ]}
    />
  );
}

export default ReturningTasksActionButton;
